type PayloadWithRequestorFields = {
  primary_reviewer?: string | null;
  additional_notification_emails?: string[];
};

/**
 * Strips primary_reviewer and additional_notification_emails when the selected
 * role is not the Requestor role (or requestorRoleId is missing).
 */
export function applyRequestorFields<T extends PayloadWithRequestorFields>(
  payload: T,
  selectedRoleId: string | null | undefined,
  requestorRoleId: string | undefined
): T {
  const isRequestor =
    Boolean(requestorRoleId) && selectedRoleId === requestorRoleId;
  const { primary_reviewer, additional_notification_emails, ...rest } = payload;

  if (!isRequestor) {
    return rest as T;
  }

  return {
    ...rest,
    primary_reviewer: primary_reviewer ?? null,
    additional_notification_emails:
      additional_notification_emails?.filter(Boolean) ?? [],
  } as T;
}
